module.exports = {
  EnrichedAudio: {
    Allow_fullscreen: "Permitir Pantalla Completa",
    Show_controls: "Mostrar Controles",
    Autoplay: "Reproducción Automática",
    Waves: "Ondas",
    BarWidth: "Grosor de Onda",
    ProgressColor: "Color del Progreso",
    WaveColor: "Color de la Onda",
    URL: "URL",
    Audio: "Audio",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    PluginName: "Reproductor Audio",
    player: "Estilo del Reproductor",
    radius: "Radio",
    pos: "Posición",
    Scroll: "Scroll",
    source: "Origen",
    message_mark_error:
      "Ha introducido un valor incorrecto. Debe introducir el tiempo en el formato hh:mm:ss o mm:ss. Ej. 1:33",
  },
};
